import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = { class: "card-header border-0 pt-5" }
const _hoisted_3 = { class: "card-title align-items-start flex-column" }
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = { class: "d-flex align-items-center position-relative my-1" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_7 = { class: "card-body py-3" }
const _hoisted_8 = { class: "table-responsive" }
const _hoisted_9 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Nama Siswa"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Nomor Identitas"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Jenis Kelamin"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Tags"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Status"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Aksi")
  ])
], -1)
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "text-center" }
const _hoisted_13 = { class: "text-center" }
const _hoisted_14 = { class: "text-center" }
const _hoisted_15 = { class: "text-center" }
const _hoisted_16 = { class: "text-center" }
const _hoisted_17 = {
  key: 0,
  class: "badge badge-success"
}
const _hoisted_18 = {
  key: 1,
  class: "badge badge-danger"
}
const _hoisted_19 = {
  key: 2,
  class: "badge badge-info"
}
const _hoisted_20 = { class: "text-center" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/detail.svg",
  alt: ""
}, null, -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { key: 1 }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "6",
    style: {"text-align":"center"}
  }, "Tidak Ada Data")
], -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = { class: "row mt-5 mb-5" }
const _hoisted_28 = { class: "col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start" }
const _hoisted_29 = {
  class: "dataTables_length",
  id: "kt_customers_table_length"
}
const _hoisted_30 = ["label", "value"]
const _hoisted_31 = { class: "p-3" }
const _hoisted_32 = { class: "col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end" }
const _hoisted_33 = { class: "pagination" }
const _hoisted_34 = {
  class: "modal fade",
  tabindex: "-1",
  "aria-hidden": "true",
  "data-bs-backdrop": "static",
  id: "kt_modal_response_detail_history"
}
const _hoisted_35 = { class: "modal-dialog modal-dialog-scrollable modal-dialog-centered modal-lg" }
const _hoisted_36 = { class: "modal-content rounded" }
const _hoisted_37 = { class: "modal-header pb-0 border-0 justify-content-end" }
const _hoisted_38 = { class: "svg-icon svg-icon-1" }
const _hoisted_39 = { class: "modal-body scroll-y px-10 px-lg-15 pt-0 pb-15" }
const _hoisted_40 = { class: "card-body p-9" }
const _hoisted_41 = { class: "row mb-7" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-3 fw-bold" }, "Nama ", -1)
const _hoisted_43 = { class: "col-lg-9 mt--9" }
const _hoisted_44 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_45 = { class: "row mb-7" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-3 fw-bold" }, "Nomor Identitas ", -1)
const _hoisted_47 = { class: "col-lg-9 mt--9" }
const _hoisted_48 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_49 = { class: "row mb-7" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-3 fw-bold" }, "Jenis Kelamin ", -1)
const _hoisted_51 = { class: "col-lg-9 mt--9" }
const _hoisted_52 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_53 = { class: "row mb-7" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-3 fw-bold" }, "Tags ", -1)
const _hoisted_55 = { class: "col-lg-9 mt--9" }
const _hoisted_56 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_57 = { class: "row mb-7" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-3 fw-bold" }, "Status ", -1)
const _hoisted_59 = { class: "col-lg-9 mt--9" }
const _hoisted_60 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_61 = {
  key: 0,
  class: "badge badge-success"
}
const _hoisted_62 = {
  key: 1,
  class: "badge badge-danger"
}
const _hoisted_63 = {
  key: 2,
  class: "badge badge-info"
}
const _hoisted_64 = { class: "row mb-7" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-3 fw-bold" }, "Request Katalis ", -1)
const _hoisted_66 = { class: "col-lg-9 mt--9" }
const _hoisted_67 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_68 = { class: "row mb-7" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-3 fw-bold" }, "Response Katalis ", -1)
const _hoisted_70 = { class: "col-lg-9" }
const _hoisted_71 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_72 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_json_viewer = _resolveComponent("json-viewer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.widgetClasses, "card"])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h3", _hoisted_3, [
          _createElementVNode("button", {
            class: "btn btn-success me-3",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.refreshMigrasi()))
          }, " Perbarui Status ")
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.download && _ctx.download(...args))),
              class: "btn btn-md btn-info"
            }, " Download "),
            _hoisted_6,
            _createElementVNode("button", {
              class: "btn btn-primary me-3",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/superadmin/siswa/history')))
            }, " Kembali ")
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("table", _hoisted_9, [
            _hoisted_10,
            (_ctx.tableData.length)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", _hoisted_12, _toDisplayString(item.name), 1),
                      _createElementVNode("td", _hoisted_13, _toDisplayString(item.identityNumber), 1),
                      _createElementVNode("td", _hoisted_14, _toDisplayString(item.request_katalis.gender == "MALE"
                      ? "Laki-laki"
                      : "Perempuan"), 1),
                      _createElementVNode("td", _hoisted_15, _toDisplayString(item.request_katalis.tags.join(", ")), 1),
                      _createElementVNode("td", _hoisted_16, [
                        (item.status == 'SUCCESS')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_17, " Sukses "))
                          : _createCommentVNode("", true),
                        (item.status == 'FAILED')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_18, " Gagal "))
                          : _createCommentVNode("", true),
                        (item.status == 'REFRESH')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_19, " Refresh "))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", _hoisted_20, [
                        _createElementVNode("a", {
                          class: "symbol symbol-35px me-2",
                          "data-bs-toggle": "tooltip",
                          title: "Detail",
                          style: {"cursor":"pointer"},
                          onClick: ($event: any) => (_ctx.detailHistoryResponse(item, index))
                        }, _hoisted_23, 8, _hoisted_21)
                      ])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_24, _hoisted_26))
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("label", null, [
                _withDirectives(_createElementVNode("select", {
                  name: "kt_customers_table_length",
                  class: "form-select form-select-sm form-select-solid",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.paging.size) = $event)),
                  placeholder: "Per page",
                  onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changePageSize()))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paging.perPageOptions, (item) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: item,
                      label: item,
                      value: item
                    }, null, 8, _hoisted_30))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.paging.size]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_31, " Showing " + _toDisplayString(_ctx.from + 1) + " to " + _toDisplayString(_ctx.to) + " of " + _toDisplayString(_ctx.paging.totalElements) + " entries ", 1)
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("ul", _hoisted_33, [
              _createElementVNode("li", {
                class: _normalizeClass(["page-item previous", { disabled: _ctx.paging.page + 1 === 1 }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  style: {"cursor":"pointer"},
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args)))
                }, " Previous ")
              ], 2),
              _createElementVNode("li", {
                class: _normalizeClass(["page-item next", { disabled: _ctx.paging.page + 1 === _ctx.paging.totalPages }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  style: {"cursor":"pointer"},
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)))
                }, " Next ")
              ], 2)
            ])
          ])
        ])
      ])
    ], 2),
    _createElementVNode("div", _hoisted_34, [
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", {
              class: "btn btn-sm btn-icon btn-active-color-primary",
              "data-bs-dismiss": "modal",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.kembaliHistory()))
            }, [
              _createElementVNode("span", _hoisted_38, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _hoisted_42,
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.name), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_45, [
                _hoisted_46,
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.identityNumber), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_49, [
                _hoisted_50,
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.gender == "MALE" ? "Laki-laki" : "Perempuan"), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_53, [
                _hoisted_54,
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.tags.join(", ")), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_57, [
                _hoisted_58,
                _createElementVNode("div", _hoisted_59, [
                  _createElementVNode("span", _hoisted_60, [
                    (_ctx.status == 'SUCCESS')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_61, " Sukses "))
                      : _createCommentVNode("", true),
                    (_ctx.status == 'FAILED')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_62, " Gagal "))
                      : _createCommentVNode("", true),
                    (_ctx.status == 'REFRESH')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_63, " Refresh "))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_64, [
                _hoisted_65,
                _createElementVNode("div", _hoisted_66, [
                  _createElementVNode("span", _hoisted_67, [
                    _createVNode(_component_json_viewer, {
                      value: _ctx.request_katalis,
                      "expand-depth": 5,
                      copyable: "",
                      boxed: "",
                      sort: ""
                    }, null, 8, ["value"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_68, [
                _hoisted_69,
                _createElementVNode("div", _hoisted_70, [
                  _createElementVNode("span", _hoisted_71, [
                    _createVNode(_component_json_viewer, {
                      value: _ctx.response_katalis,
                      "expand-depth": 5,
                      copyable: "",
                      boxed: "",
                      sort: ""
                    }, null, 8, ["value"])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_72, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-danger me-3",
              "data-bs-dismiss": "modal",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.kembaliHistory()))
            }, " Kembali ")
          ])
        ])
      ])
    ])
  ], 64))
}